import { ChangeEvent } from "react";

interface Props<T extends string | number> {
  id?: string;
  name?: string;
  label?: string | JSX.Element;
  value?: T;
  className?: string;
  containerClassName?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (ev: ChangeEvent<HTMLInputElement>) => void;
  errors?: string[];
}

export default function CheckboxField<T extends string | number>({
  id,
  name,
  label,
  value,
  checked,
  className,
  disabled,
  onChange,
  errors,
  containerClassName,
  ...other
}: Props<T>) {
  const classNames = ["disabled:opacity-30", className].join(" ");
  const hasError = errors && errors.length > 0;
  return (
    <>
      <div
        className={`flex items-center space-x-2${
          disabled ? " pointer-events-none" : ""
        } ${containerClassName || ""}`}
      >
        <input
          id={id}
          name={name}
          type="checkbox"
          value={value}
          className={classNames}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          {...other}
          style={{
            backgroundPositionX: "5px",
          }}
        />
        {label && (
          <label
            htmlFor={id}
            className="block disabled:opacity-30 cursor-pointer"
          >
            {label}
          </label>
        )}
      </div>
      {hasError && (
        <ul>
          {errors?.map((message, i) => (
            <li key={i} className="text-sm text-accent">
              {message}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
